import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '@/layouts/MainLayout.vue'

const routes = [
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        path: '/',
        name: 'Home',
        component: () => import("@/views/HomeView.vue"),
        meta: {
          title: '北京纵硕科技有限公司',
          requiresAuth: false
        },
      },{
        path: '/service',
        name: 'Service',
        component: () => import("@/views/ServiceView.vue"),
        meta: {
          title: '解决方案-北京纵硕科技有限公司',
          requiresAuth: false
        }
      },{
        path: '/case',
        name: 'Case',
        component: () => import("@/views/CaseView.vue"),
        meta: {
          title: '客户案例-北京纵硕科技有限公司',
          requiresAuth: false
        }
      },{
        path: '/technical',
        name: 'Technical',
        component: () => import("@/views/TechnicalView.vue"),
        redirect: '/technical/support',
        meta: {
          title: '技术支持-北京纵硕科技有限公司',
          requiresAuth: false
        },
        children: [
          {
            path: 'support',
            name: 'Support',
            component: () => import("@/components/technical/TechnicalSupport.vue"),
            meta: {
              title: '技术支持-北京纵硕科技有限公司',
              requiresAuth: false
            },
          },
          {
            path: 'faq',
            name: 'FAQ',
            component: () => import("@/components/technical/FAQ.vue"),
            meta: {
              title: '常见问题-北京纵硕科技有限公司',
              requiresAuth: false
            },
          },
          {
            path: 'device',
            name: 'DeviceHelp',
            component: () => import("@/components/technical/DeviceHelp.vue"),
            meta: {
              title: '设备答疑-北京纵硕科技有限公司',
              requiresAuth: false
            },
          },
          {
            path: 'service',
            name: 'TechnicalService',
            component: () => import("@/components/technical/TechnicalService.vue"),
            meta: {
              title: '售后服务-北京纵硕科技有限公司',
              requiresAuth: false
            },
          }
        ]
      },{
        path: '/about',
        name: 'About',
        component: () => import("@/views/AboutView.vue"),
        meta: {
          title: '关于我们-北京纵硕科技有限公司',
          requiresAuth: false
        }
      },{
        path: '/contact',
        name: 'Contact',
        component: () => import("@/views/ContactView.vue"),
        meta: {
          title: '联系我们-北京纵硕科技有限公司',
          requiresAuth: false
        }
      },{
        path: '/paper',
        name: 'PaperLess',
        component: () => import('@/components/service/PaperlessMeet.vue'),
        meta: {
          title: '无纸化会议系统-北京纵硕科技有限公司',
          requiresAuth: false
        },
      },{
        path: '/meet',
        name: 'SmartMeet',
        component: () => import("@/components/service/SmartMeet.vue"),
        meta: {
          title: '数字会议系统-北京纵硕科技有限公司',
          requiresAuth: false
        },
      },{
        path: '/agent',
        name: 'Agent',
        component: () => import("@/components/agent/AgentService.vue"),
        meta: {
          title: '智能体服务-北京纵硕科技有限公司',
          requiresAuth: false
        }
      },{
        path: '/test',
        name: 'Test',
        component: () => import("@/views/TestA.vue"),
        meta: {
          title: 'test',
          requiresAuth: false
        },
      }
    ]
}]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 }
  }
})

router.beforeEach((to) => {
  document.title = to.meta.title || '北京纵硕科技有限公司'
})

export default router
